<app-page-container class="flex-page">
    <div class="bg-article">
        <div class="bg-main-section">
            <div fxLayout="column">
                <div class="mat-title">{{ pageTitle }}</div>

                <p class="mat-body-1">
                    Μπορείτε να προγραμματίσετε ηλεκτρονικό ραντεβού και να εξυπηρετηθείτε στις αρμόδιες Yπηρεσίες της Περιφέρειας
                </p>

                <span class="mat-body-1">Θα χρειαστείτε:</span>
                <ul style="margin-bottom: 2em" class="mat-body-1">
                    <li>την διεύθυνση ηλεκτρονικού σας ταχυδρομείου (email)</li>
                    <li>τον αριθμό του κινητού σας τηλεφώνου</li>
                </ul>

                <!-- <div>Επιλέξτε Περιφερειακή Ενότητα για να συνεχίσετε</div> -->
                <span class="mat-body-1" style="margin-bottom: 0.7em">Επιλέξτε Περιφερειακή Ενότητα για να συνεχίσετε</span>

                <mat-form-field>
                    <mat-select [formControl]="selectedRegUnit" tabindex="1">
                        <mat-option *ngFor="let regUnit of regUnits" [value]="regUnit">{{ regUnit.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div>
                    <a
                        mat-raised-button
                        color="primary"
                        tabindex="2"
                        [routerLink]="selectedRegUnit.value?.uid"
                        [disabled]="!selectedRegUnit.value">
                        <span>Είσοδος στην υπηρεσία</span>
                        <mat-icon class="material-icons">chevron_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
        <div class="bg-side-section">
            <p class="mat-body-1" style="margin-bottom: 1em">Χρήσιμοι σύνδεσμοι</p>
            <mat-divider></mat-divider>
            <ul class="links">
                <li *ngFor="let link of links">
                    <a [href]="link.link" target="_blank">{{ link.label }}</a>
                </li>
            </ul>
        </div>
    </div>
</app-page-container>
